import { createSelector } from '@reduxjs/toolkit'
import { sortCheckpointableEntities } from '../../../helpers/sortCheckpointableEntities'
import {
  getOverdueAssignmentsIds,
  getOverduePhaseItemsIds,
} from '../../getters/entities/approvalIds'
import { NormalizedApproval } from '../types'
import { selectNormalizedApprovals } from './normalizedApprovals'

const selectOverdueAssignmentIds = createSelector(
  [getOverdueAssignmentsIds],
  (overdueAssignmentIds) => overdueAssignmentIds || []
)

const selectOverduePhaseItemIds = createSelector(
  [getOverduePhaseItemsIds],
  (overduePhaseItemIds) => overduePhaseItemIds || []
)

export const selectOverdueApprovals = createSelector(
  [
    selectNormalizedApprovals,
    selectOverdueAssignmentIds,
    selectOverduePhaseItemIds,
  ],
  (normalizedApprovals, overdueAssignmentIds, overduePhaseItemIds) => {
    const phaseItems = overduePhaseItemIds.map((id) =>
      normalizedApprovals.find(
        (approval) => approval.id === id && approval.entityType === 'phase_item'
      )
    )

    const assignments = overdueAssignmentIds.map((id) =>
      normalizedApprovals.find(
        (approval) => approval.id === id && approval.entityType === 'assignment'
      )
    )

    return sortCheckpointableEntities(
      [...phaseItems, ...assignments].filter(
        (approval): approval is NormalizedApproval => approval !== undefined
      )
    )
  }
)
